sew-ws-basket {
    display: block;

    > .headline {
        @include typo-ws-h3;

        margin: 8px 16px 0 0;
    }

    table {
        border-collapse: collapse;
        margin-top: 24px;
        width: 100%;
    }

    tr {
        border-top: 1px solid $color-grey-04-middle;
    }

    tr:last-of-type {
        td {
            padding: 8px 0 0;
        }
    }

    td {
        padding: 8px 0;

        &:last-of-type {
            text-align: end;
        }
    }

    sew-ws-linklist-menu {
        margin-top: 24px;
    }

    sew-ws-button {
        width: 100%;
        margin-top: 40px;
    }
}
